import { render, staticRenderFns } from "./VRichText.vue?vue&type=template&id=5b5db98c&scoped=true"
import script from "./VRichText.vue?vue&type=script&lang=js"
export * from "./VRichText.vue?vue&type=script&lang=js"
import style0 from "./VRichText.vue?vue&type=style&index=0&id=5b5db98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5db98c",
  null
  
)

export default component.exports